import React, { MouseEvent } from "react";
import { StyledOpenPickerButton } from "./OpenPickerButton.styled";
import { CalendarIcon } from "../CalendarIcon";
import { FC } from "../../../../types";

interface OpenPickerButtonProps {
  isDisabled?: boolean;
  onClick?(e: MouseEvent<HTMLButtonElement>): void;
}

export const OpenPickerButton: FC<OpenPickerButtonProps> = (props) => {
  const { isDisabled, onClick } = props;

  return (
    <StyledOpenPickerButton disabled={isDisabled} onClick={onClick}>
      <CalendarIcon />
    </StyledOpenPickerButton>
  );
};
